var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRemoveCircleOutline = function SvgRemoveCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4zm5 9a1 1 0 110 2H9a1 1 0 110-2h10z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDJDMjAuNjI3NCAyIDI2IDcuMzcyNTggMjYgMTRDMjYgMjAuNjI3NCAyMC42Mjc0IDI2IDE0IDI2QzcuMzcyNTggMjYgMiAyMC42Mjc0IDIgMTRDMiA3LjM3MjU4IDcuMzcyNTggMiAxNCAyWk0xNCA0QzguNDc3MTUgNCA0IDguNDc3MTUgNCAxNEM0IDE5LjUyMjggOC40NzcxNSAyNCAxNCAyNEMxOS41MjI4IDI0IDI0IDE5LjUyMjggMjQgMTRDMjQgOC40NzcxNSAxOS41MjI4IDQgMTQgNFpNMTkgMTNDMTkuNTUyMyAxMyAyMCAxMy40NDc3IDIwIDE0QzIwIDE0LjU1MjMgMTkuNTUyMyAxNSAxOSAxNUg5QzguNDQ3NzIgMTUgOCAxNC41NTIzIDggMTRDOCAxMy40NDc3IDguNDQ3NzIgMTMgOSAxM0gxOVoiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgRemoveCircleOutline as ReactComponent };